/* Le Studio : bascule téléphone/ordinateur, aperçu plein écran,
   téléchargements. Les tuiles sont rendues côté Liquid (métaobjets
   wallpaper) ; chaque tuile porte en data-tel / data-ordi l'URL de son
   fichier de téléchargement : un ZIP NON COMPRESSÉ contenant le JPEG
   original octet pour octet (le CDN Shopify recompresse toute image
   qu'il sert, quel que soit le chemin — le zip est le seul conteneur
   qu'il laisse intact). Au clic on récupère le zip, on en découpe le
   JPEG (entrée STORED : offset fixe + tailles dans l'en-tête local) et
   on télécharge/partage un vrai .jpg à la qualité d'origine.
   Desktop : blob + <a download>. Tactile : Web Share API (feuille de
   partage → Photos), sinon aperçu plein écran de l'original + appui
   long. */
(function () {
  'use strict';

  var studio = document.querySelector('.studio');
  var grille = document.getElementById('st-grille');
  if (!studio || !grille) return;
  var zoom = document.getElementById('st-zoom');
  var zoomImg = zoom.querySelector('img');
  var zoomHint = zoom.querySelector('.st-zoom-hint');
  var tactile = window.matchMedia('(pointer: coarse)').matches;
  var derniereFocus = null;

  /* ---- garde-fou téléchargements : pas de rafale ----
     Cooldown entre deux téléchargements + plafond par session (les
     fichiers restent des URLs CDN publiques : c'est un frein contre le
     clic compulsif, pas un contrôle d'accès). */
  var dernierDl = 0;
  var nbSession = 0;
  try { nbSession = parseInt(sessionStorage.getItem('st-dl-n'), 10) || 0; } catch (e) {}
  function autorise() {
    var t = Date.now();
    if (t - dernierDl < 2500) return false;
    if (nbSession >= 25) {
      alert(grille.getAttribute('data-msg-limite'));
      return false;
    }
    dernierDl = t;
    nbSession++;
    try { sessionStorage.setItem('st-dl-n', String(nbSession)); } catch (e) {}
    return true;
  }

  /* ---- tri par le champ ordre des métaobjets ---- */
  var tuiles = Array.prototype.slice.call(grille.querySelectorAll('.st-tuile'));
  tuiles.sort(function (a, b) { return a.getAttribute('data-ordre') - b.getAttribute('data-ordre'); });
  tuiles.forEach(function (t) { grille.appendChild(t); });

  function urlDe(tuile, format) {
    return tuile.getAttribute('data-' + format);
  }
  function nomDe(tuile, format) {
    return tuile.getAttribute('data-nom-' + format);
  }

  /* ---- extraction du JPEG original depuis le zip STORED ----
     En-tête local de zip : signature (4), versions/flags (22), taille
     stockée à l'octet 18, longueurs du nom et de l'extra à 26 et 28 ;
     les données commencent à 30 + nom + extra. Aucune décompression :
     l'entrée est STORED, on découpe juste les octets d'origine. */
  function extraireJpeg(buffer) {
    var dv = new DataView(buffer);
    if (buffer.byteLength < 30 || dv.getUint32(0, true) !== 0x04034b50) {
      return buffer; /* pas un zip (fallback assets de démo) : octets bruts */
    }
    var taille = dv.getUint32(18, true);
    var debut = 30 + dv.getUint16(26, true) + dv.getUint16(28, true);
    if (!taille || debut + taille > buffer.byteLength) return buffer;
    return buffer.slice(debut, debut + taille);
  }
  function recupereOriginal(tuile, format) {
    return fetch(urlDe(tuile, format))
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.arrayBuffer();
      })
      .then(function (buf) {
        return new Blob([extraireJpeg(buf)], { type: 'image/jpeg' });
      });
  }

  /* ---- bascule téléphone / ordinateur ---- */
  var boutonsMode = document.querySelectorAll('.st-toggle button');
  boutonsMode.forEach(function (b) {
    b.addEventListener('click', function () {
      var mode = b.getAttribute('data-mode');
      if (studio.getAttribute('data-mode') === mode) return;
      boutonsMode.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      grille.classList.add('bascule');
      setTimeout(function () {
        studio.setAttribute('data-mode', mode);
        grille.classList.remove('bascule');
      }, 180);
    });
  });

  function telechargerDirect(tuile, format, btn) {
    btn.disabled = true;
    recupereOriginal(tuile, format)
      .then(function (blob) {
        var u = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = u;
        a.download = nomDe(tuile, format);
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(function () { URL.revokeObjectURL(u); }, 4000);
      })
      .catch(function () {
        /* dernier recours : le zip en direct, à décompresser à la main */
        var a = document.createElement('a');
        a.href = urlDe(tuile, format);
        a.download = nomDe(tuile, format).replace('.jpg', '.zip');
        document.body.appendChild(a);
        a.click();
        a.remove();
      })
      .then(function () { btn.disabled = false; }, function () { btn.disabled = false; });
  }

  function partagerOuApercu(tuile, format, btn) {
    btn.disabled = true;
    recupereOriginal(tuile, format)
      .then(function (blob) {
        if (navigator.canShare) {
          var f = new File([blob], nomDe(tuile, format), { type: 'image/jpeg' });
          if (navigator.canShare({ files: [f] })) return navigator.share({ files: [f] });
        }
        ouvrirZoomBlob(tuile, blob);
      })
      .catch(function (e) {
        /* partage annulé par l'utilisateur : ne rien faire */
        if (e && e.name === 'AbortError') return;
      })
      .then(function () { btn.disabled = false; }, function () { btn.disabled = false; });
  }

  /* ---- aperçu plein écran ---- */
  var zoomBlobUrl = null;
  function montreZoom(src, alt, avecHint) {
    zoomImg.src = src;
    zoomImg.alt = alt;
    /* le hint « appui long pour enregistrer » ne s'affiche que quand le
       zoom montre l'ORIGINAL (plan B du téléchargement tactile) : sur un
       simple aperçu compressé, il ferait enregistrer la mauvaise version */
    zoomHint.hidden = !avecHint;
    derniereFocus = document.activeElement;
    zoom.hidden = false;
    void zoom.offsetHeight; /* reflow forcé pour que la transition parte de opacity:0 */
    zoom.classList.add('on');
    zoom.querySelector('.st-zoom-close').focus();
  }
  /* loupe : l'aperçu compressé du mode courant (transformation CDN) */
  function ouvrirZoom(tuile, format) {
    var src = tuile.getAttribute('data-zoom-' + format) || urlDe(tuile, format);
    montreZoom(src, tuile.getAttribute('data-alt') || '', false);
  }
  /* plan B tactile : l'original extrait du zip, en blob local */
  function ouvrirZoomBlob(tuile, blob) {
    if (zoomBlobUrl) URL.revokeObjectURL(zoomBlobUrl);
    zoomBlobUrl = URL.createObjectURL(blob);
    montreZoom(zoomBlobUrl, tuile.getAttribute('data-alt') || '', true);
  }
  function fermerZoom() {
    zoom.classList.remove('on');
    setTimeout(function () {
      zoom.hidden = true;
      zoomImg.src = '';
      if (zoomBlobUrl) { URL.revokeObjectURL(zoomBlobUrl); zoomBlobUrl = null; }
    }, 220);
    if (derniereFocus) derniereFocus.focus();
  }
  zoom.querySelector('.st-zoom-close').addEventListener('click', fermerZoom);
  zoom.addEventListener('click', function (e) { if (e.target === zoom) fermerZoom(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !zoom.hidden) fermerZoom();
  });

  /* ---- délégation des clics ---- */
  document.addEventListener('click', function (e) {
    var dl = e.target.closest('.st-dl');
    if (dl) {
      if (dl.disabled || !autorise()) return;
      var tuile = dl.closest('.st-tuile');
      var format = dl.getAttribute('data-format');
      if (tactile) partagerOuApercu(tuile, format, dl);
      else telechargerDirect(tuile, format, dl);
      return;
    }
    var ph = e.target.closest('.st-ph');
    if (ph) {
      ouvrirZoom(ph.closest('.st-tuile'), studio.getAttribute('data-mode'));
    }
  });
})();
